/* eslint-disable no-unused-expressions */
import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'reactstrap'
import { Select, MenuItem, Box } from '@material-ui/core'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import CircularProgress from '@material-ui/core/CircularProgress'
import Moment from 'react-moment'
import moment from 'moment'

import LineWrap from './LineWrap'
import BarWrap from './BarWrap'
import SOVColors from '../../constants/colors'

import './DashboardComponent.scss'
import { MEDIA_COMPANY, MEDIA_COMPANY_COLON, MEDIA_COMPANY_OTHERS, MEDIA_COMPANY_PARAMOUNT, MEDIA_COMPANY_VIACOMCBS, OTHER } from '../../constants/sov'
import { NONE } from '../../constants/commons'

export default class SOVNetworks extends React.Component {
  static propTypes = {
    sovNetworks: PropTypes.object,
    selectedCategory: PropTypes.string,
    setSelectedNetwork: PropTypes.func,
    setSelectedCategory: PropTypes.func,
    dateArray: PropTypes.array,
    dateIndex: PropTypes.number,
    setDateIndex: PropTypes.func
  }

  constructor (props) {
    super(props)

    this.state = {
        screenWidth: window.innerWidth,
        actionState: 'line',
        sovNetworks: null,
        details: [],
        sovNetwork1: null,
        sovNetwork2: null,
        sovNetwork3: null,
        sovNetwork4: null,
        sovNetwork5: null,
        selectedNetwork: [],
        isExpanded: false,
        expandedIndex: 0
    }
    this.divRef = React.createRef()
  }

  componentDidMount () {
    this.setState({ details: this.props.sovNetworks?.details || [] })
    this.setupSOVNetworkData(this.props.sovNetworks?.details || [])
  }

  componentDidUpdate (prevProps) {
    if (prevProps.selectedCategory !== this.props.selectedCategory) {
      this.setState({ selectedNetwork: [], actionState: 'line' })
      this.props.setSelectedNetwork([])
    }
    if (prevProps.selectedCategory !== this.props.selectedCategory && prevProps.sovNetworks !== this.props.sovNetworks && this.props.sovNetworks?.details) {
      this.setupSOVNetworkData(this.props.sovNetworks.details)
    }
    if (prevProps.sovNetworks !== this.props.sovNetworks && this.props.sovNetworks?.details) {
      const details = this.props.sovNetworks.details
      this.setState({ details: details })
      this.setupSOVNetworkData(details)
    }
  }

  setupSOVNetworkData = (details) => {
    let exists = details.find(n => n.label === NONE)
    // Support for "None" in network dropdowns
    if (!exists && details.length > 0) {
      details.push({
        label: NONE,
        metrics: [],
        score: 0
      })
    }
    this.setState({
      sovNetworks: details,
      sovNetwork1: details.length > 0 ? details[0] : null,
      sovNetwork2: details.length > 1 ? details[1] : null,
      sovNetwork3: details.length > 2 && details[2].label !== NONE ? details[2] : null,
      sovNetwork4: details.length > 3 && details[3].label !== NONE ? details[3] : null,
      sovNetwork5: details.length > 4 && details[4].label !== NONE ? details[4] : null
    })
    SOVColors.getSOVHoverColors (details.length > 0 ? details[0].label : null, 'network1')
    SOVColors.getSOVHoverColors (details.length > 1 ? details[1].label : null, 'network2')
    SOVColors.getSOVHoverColors (details.length > 2 ? details[2].label : null, 'network3')
    SOVColors.getSOVHoverColors (details.length > 3 ? details[3].label : null, 'network4')
    SOVColors.getSOVHoverColors (details.length > 4 ? details[4].label : null, 'network5')
  }

  handleNetworkChange = (e, index) => {
    const select = this.state.sovNetworks.filter(n => n.label === e.target.value)[0]
    switch (index) {
      case 1:
        this.setState({ sovNetwork1: select })
        SOVColors.getSOVHoverColors (select.label, 'network1')
        break
      case 2:
        this.setState({ sovNetwork2: select })
        SOVColors.getSOVHoverColors (select.label, 'network2')
        break
      case 3:
        this.setState({ sovNetwork3: select })
        SOVColors.getSOVHoverColors (select.label, 'network3')
        break
      case 4:
        this.setState({ sovNetwork4: select })
        SOVColors.getSOVHoverColors (select.label, 'network4')
        break
      case 5:
        this.setState({ sovNetwork5: select })
        SOVColors.getSOVHoverColors (select.label, 'network5')
        break
    }
    this.setState({ selectedNetwork: [] })
    this.props.setSelectedNetwork([])
  }

  handleNetworkSelect = (event, index) => {
    if (event.target.value || event?.target?.className?.indexOf('networkPercent') === -1) {
      return null
    }
    let selectedNetwork = this.state.selectedNetwork
    let exists = false
    switch (index) {
      case 1:
        exists = selectedNetwork.find(n => n === this.state.sovNetwork1.label)
        if (exists) {
          selectedNetwork = selectedNetwork.filter(n => n !== this.state.sovNetwork1.label)
        } else {
          selectedNetwork.push(this.state.sovNetwork1.label)
        }
        break
      case 2:
        exists = selectedNetwork.find(n => n === this.state.sovNetwork2.label)
        if (exists) {
          selectedNetwork = selectedNetwork.filter(n => n !== this.state.sovNetwork2.label)
        } else {
          selectedNetwork.push(this.state.sovNetwork2.label)
        }
        break
      case 3:
        exists = selectedNetwork.find(n => n === this.state.sovNetwork3.label)
        if (exists) {
          selectedNetwork = selectedNetwork.filter(n => n !== this.state.sovNetwork3.label)
        } else {
          selectedNetwork.push(this.state.sovNetwork3.label)
        }
        break
      case 4:
        exists = selectedNetwork.find(n => n === this.state.sovNetwork4.label)
        if (exists) {
          selectedNetwork = selectedNetwork.filter(n => n !== this.state.sovNetwork4.label)
        } else {
          selectedNetwork.push(this.state.sovNetwork4.label)
        }
        break
      case 5:
        exists = selectedNetwork.find(n => n === this.state.sovNetwork5.label)
        if (exists) {
          selectedNetwork = selectedNetwork.filter(n => n !== this.state.sovNetwork5.label)
        } else {
          selectedNetwork.push(this.state.sovNetwork5.label)
        }
        break
    }
    this.setState({ selectedNetwork: selectedNetwork })
    this.props.setSelectedNetwork(selectedNetwork)
  }

  getAveragePerDay = (sovNetwork, selectedDate) => {
    const sovNetworkAverage = sovNetwork && sovNetwork.metrics.length > 0 && sovNetwork.metrics.find(m => m.date === selectedDate) ? sovNetwork.metrics.find(m => m.date === selectedDate).score : 0
    return Math.round(sovNetworkAverage * 100) / 100
  }

  getAverage = (sovNetwork, averagePerDay) => {
    const sovNetworkAverage = sovNetwork && sovNetwork.score
    return Math.round((averagePerDay - sovNetworkAverage) * 100) / 100
  }


  handleDropdownOpen = (event, index) => {
    this.setState({ isExpanded: true, expandedIndex: index })
  }
  handleDropdownClose = () => {
    this.setState({ isExpanded: false, expandedIndex: 0 })
  }
  getDisplayTitle = (title, index) => {
    const { screenWidth } = this.state
    let displayName = title.replace(MEDIA_COMPANY_COLON, '').replace(MEDIA_COMPANY_VIACOMCBS, MEDIA_COMPANY_PARAMOUNT).replace(MEDIA_COMPANY_OTHERS, OTHER)
    // To show only ellipses text in the box and full text without ellipses in the dropdown
    if (!this.state.isExpanded || (this.state.isExpanded && index !== this.state.expandedIndex) || this.state.expandedIndex === 0) {
      const charLength = screenWidth < 375 ? 50 : screenWidth >= 375 && screenWidth < 479.95 ? 50
      : screenWidth >= 480 && screenWidth < 767.98 ? 50
      : screenWidth >= 768 && screenWidth < 1023.98 ? 11
      : screenWidth >= 1024 && screenWidth < 1219.98 ? 12
      : screenWidth >= 1220 && screenWidth < 1339.98 ? 13
      : screenWidth >= 1340 && screenWidth <= 1440 ? 14
      : (screenWidth > 1440) ? 18 : 50

      if (displayName && displayName.length > charLength) {
        const tooltip = <Tooltip id="tooltip">{displayName}</Tooltip>
        return (
          <OverlayTrigger overlay={tooltip} placement='top'>
            <span className="txt">{displayName.substring(0, charLength)}...</span>
          </OverlayTrigger>
        )
      }
    }
    return (<span>{displayName}</span>)
  }

  render () {
    const { sovNetworks, sovNetwork1, sovNetwork2, sovNetwork3, sovNetwork4, sovNetwork5 } = this.state
    const actionSelect = (val) => {
      this.setState({ actionState: val })
    }
    const selectedDate = moment(new Date(this.props.dateArray[this.props.dateIndex])).format('YYYY-MM-DD')
    const sovNetwork1Average = this.getAveragePerDay(sovNetwork1, selectedDate)
    const sovNetwork2Average = this.getAveragePerDay(sovNetwork2, selectedDate)
    const sovNetwork3Average = this.getAveragePerDay(sovNetwork3, selectedDate)
    const sovNetwork4Average = this.getAveragePerDay(sovNetwork4, selectedDate)
    const sovNetwork5Average = this.getAveragePerDay(sovNetwork5, selectedDate)
    const networkStyle = (network) => {
      return {
        borderColor: SOVColors.getSOVColors(network),
        color: SOVColors.getSOVColors(network)
      }
    }
    const networkBoxStyle = (network) => {
      return { backgroundColor: SOVColors.getSOVColors(network) }
    }
    const networkDotStyle = (network) => {
      return { backgroundColor: SOVColors.getSOVColors(network) }
    }
    const networkLabelStyle = (network) => {
      return { color: SOVColors.getSOVColors(network) }
    }

    return (
      <>
        <Box>
          <Row>
            <Col xl={9}>
              <span className="cardTitle">Network Share of Conversation</span>
              <OverlayTrigger overlay={<Tooltip id="tooltip">Network Share of Conversation</Tooltip>} placement="right">
                <img src="/static/images/info.png" alt="info" className="cardInfo" />
              </OverlayTrigger>
              <p className='subTxt'>The percent share of engagement for the specified networks and platforms</p>
            </Col>
            <Col xl={3} id='dateSelect' className='dateSelect'>
              <Box className='datePicker'>
                <img className='cursorPointer' src="/static/images/arrow_left.svg" alt="info" onClick={() => this.props.setDateIndex(this.props.dateIndex <= 0 ? this.props.dateArray.length - 1 : this.props.dateIndex - 1)}/>
                <span className='dateText'>
                  <Moment format='ddd, MMM DD'>{this.props.dateArray[this.props.dateIndex]}</Moment>
                </span>
                <img className='cursorPointer' src="/static/images/arrow_right.svg" alt="info" onClick={() => this.props.setDateIndex(this.props.dateIndex >= this.props.dateArray.length - 1 ? 0 : this.props.dateIndex + 1)}/>
              </Box>
            </Col>
          </Row>
        </Box>
        { (this.props.sovNetworks && this.props.sovNetworks.isFetching) &&
        <div className='loadingProgress'>
          <CircularProgress />
        </div>
          }
        { (this.props.sovNetworks && this.props.sovNetworks.details) &&
          <>
            <Box className='selectWrap' id='networkSelect'>
              { sovNetwork1 &&
                <Box id={this.props.selectedCategory === MEDIA_COMPANY ? 'selectBoxMediaCompany' : 'selectBox'} className={this.state.selectedNetwork.find(n => n === sovNetwork1.label) ? 'selectBox networkOne networkPercent boxSelect' : 'selectBox networkOne networkPercent'} style={this.state.selectedNetwork.find(n => n === sovNetwork1.label) ? Object.assign(networkStyle(sovNetwork1.label), networkBoxStyle(this.state.selectedNetwork.find(n => n === sovNetwork1.label))) : Object.assign(networkStyle(sovNetwork1.label), networkBoxStyle(''))} onClick={(e) => this.handleNetworkSelect(e, 1)}>
                  <Select
                    labelId="select-filled-label"
                    className='baseSelect'
                    value={sovNetwork1.label}
                    onChange={(e) => this.handleNetworkChange(e, 1)}
                    onOpen={(e) => this.handleDropdownOpen(e, 1)}
                    onClose={(e) => this.handleDropdownClose(e, 1)}
                  >
                    { sovNetworks.map((n) => {
                      if (n.label !== NONE) {
                        return (
                          <MenuItem ref={this.divRef} key={n.label} value={n.label} className='selectOptionBox'>
                            <span className='menuDot' style={networkDotStyle(n.label)}></span>
                            <Box className="d-flex flex-column pt-0">
                              <span className="optionLabel" style={networkLabelStyle(n.label)}>{this.getDisplayTitle(n.label, 1)}</span>
                            </Box>
                          </MenuItem>
                        )
                      }
                    })}
                  </Select>
                  <h5 className='contPercent networkPercent'>{sovNetwork1Average}%</h5>
                  <span className='networkPercent'>{this.getAverage(sovNetwork1, sovNetwork1Average)}% from avg</span>
                </Box>
              }
              { sovNetwork2 &&
                <Box id={this.props.selectedCategory === MEDIA_COMPANY ? 'selectBoxMediaCompany' : 'selectBox'} className={this.state.selectedNetwork.find(n => n === sovNetwork2.label) ? 'selectBox networkTwo networkPercent boxSelect' : 'selectBox networkTwo networkPercent'} style={this.state.selectedNetwork.find(n => n === sovNetwork2.label) ? Object.assign(networkStyle(sovNetwork2.label), networkBoxStyle(this.state.selectedNetwork.find(n => n === sovNetwork2.label))) : Object.assign(networkStyle(sovNetwork2.label), networkBoxStyle(''))} onClick={(e) => this.handleNetworkSelect(e, 2)}>
                  <Select
                    labelId="select-filled-label"
                    className='baseSelect'
                    value={sovNetwork2.label}
                    onChange={(e) => this.handleNetworkChange(e, 2)}
                    onOpen={(e) => this.handleDropdownOpen(e, 2)}
                    onClose={(e) => this.handleDropdownClose(e, 2)}
                  >
                    { sovNetworks.map(n => {
                      return (
                        <MenuItem key={n.label} value={n.label} className='selectOptionBox'>
                          <span className='menuDot' style={networkDotStyle(n.label)}></span>
                          <Box className="d-flex flex-column pt-0">
                            <span className="optionLabel" style={networkLabelStyle(n.label)}>{this.getDisplayTitle(n.label, 2)}</span>
                          </Box>
                        </MenuItem>
                      )
                    })}
                  </Select>
                  { sovNetwork2.label !== NONE && <h5 className='contPercent networkPercent'>{sovNetwork2Average}%</h5> }
                  { sovNetwork2.label !== NONE && <span className='networkPercent'>{this.getAverage(sovNetwork2, sovNetwork2Average)}% from avg</span> }
                </Box>
              }
              { sovNetwork3 &&
                <Box id={this.props.selectedCategory === MEDIA_COMPANY ? 'selectBoxMediaCompany' : 'selectBox'} className={this.state.selectedNetwork.find(n => n === sovNetwork3.label) ? 'selectBox networkThree networkPercent boxSelect' : 'selectBox networkThree networkPercent'} style={this.state.selectedNetwork.find(n => n === sovNetwork3.label) ? Object.assign(networkStyle(sovNetwork3.label), networkBoxStyle(this.state.selectedNetwork.find(n => n === sovNetwork3.label))) : Object.assign(networkStyle(sovNetwork3.label), networkBoxStyle(''))} onClick={(e) => this.handleNetworkSelect(e, 3)}>
                  <Select
                    labelId="select-filled-label"
                    className='baseSelect'
                    value={sovNetwork3.label}
                    onChange={(e) => this.handleNetworkChange(e, 3)}
                    onOpen={(e) => this.handleDropdownOpen(e, 3)}
                    onClose={(e) => this.handleDropdownClose(e, 3)}
                  >
                    { sovNetworks.map(n => {
                      return (
                        <MenuItem key={n.label} value={n.label} className='selectOptionBox'>
                          <span className='menuDot' style={networkDotStyle(n.label)}></span>
                          <Box className="d-flex flex-column pt-0">
                            <span className="optionLabel" style={networkLabelStyle(n.label)}>{this.getDisplayTitle(n.label, 3)}</span>
                          </Box>
                        </MenuItem>
                      )
                    })}
                  </Select>
                  { sovNetwork3.label !== NONE && <h5 className='contPercent networkPercent'>{sovNetwork3Average}%</h5> }
                  { sovNetwork3.label !== NONE && <span className='networkPercent'>{this.getAverage(sovNetwork3, sovNetwork3Average)}% from avg</span> }
                </Box>
              }
              { sovNetwork4 &&
                <Box id={this.props.selectedCategory === MEDIA_COMPANY ? 'selectBoxMediaCompany' : 'selectBox'} className={this.state.selectedNetwork.find(n => n === sovNetwork4.label) ? 'selectBox networkFour networkPercent boxSelect' : 'selectBox networkFour networkPercent'} style={this.state.selectedNetwork.find(n => n === sovNetwork4.label) ? Object.assign(networkStyle(sovNetwork4.label), networkBoxStyle(this.state.selectedNetwork.find(n => n === sovNetwork4.label))) : Object.assign(networkStyle(sovNetwork4.label), networkBoxStyle(''))} onClick={(e) => this.handleNetworkSelect(e, 4)}>
                  <Select
                    labelId="select-filled-label"
                    className='baseSelect'
                    value={sovNetwork4.label}
                    onChange={(e) => this.handleNetworkChange(e, 4)}
                    onOpen={(e) => this.handleDropdownOpen(e, 4)}
                    onClose={(e) => this.handleDropdownClose(e, 4)}
                  >
                    { sovNetworks.map(n => {
                      return (
                        <MenuItem key={n.label} value={n.label} className='selectOptionBox'>
                          <span className='menuDot' style={networkDotStyle(n.label)}></span>
                          <Box className="d-flex flex-column pt-0">
                            <span className="optionLabel" style={networkLabelStyle(n.label)}>{this.getDisplayTitle(n.label, 4)}</span>
                          </Box>
                        </MenuItem>
                      )
                    })}
                  </Select>
                  { sovNetwork4.label !== NONE && <h5 className='contPercent networkPercent'>{sovNetwork4Average}%</h5> }
                  { sovNetwork4.label !== NONE && <span className='networkPercent'>{this.getAverage(sovNetwork4, sovNetwork4Average)}% from avg</span> }
                </Box>
              }
              { sovNetwork5 &&
                <Box id={this.props.selectedCategory === MEDIA_COMPANY ? 'selectBoxMediaCompany' : 'selectBox'} className={this.state.selectedNetwork.find(n => n === sovNetwork5.label) ? 'selectBox networkFive networkPercent boxSelect' : 'selectBox networkFive networkPercent'} style={this.state.selectedNetwork.find(n => n === sovNetwork5.label) ? Object.assign(networkStyle(sovNetwork5.label), networkBoxStyle(this.state.selectedNetwork.find(n => n === sovNetwork5.label))) : Object.assign(networkStyle(sovNetwork5.label), networkBoxStyle(''))} onClick={(e) => this.handleNetworkSelect(e, 5)}>
                  <Select
                    labelId="select-filled-label"
                    className='baseSelect'
                    value={sovNetwork5.label}
                    onChange={(e) => this.handleNetworkChange(e, 5)}
                    onOpen={(e) => this.handleDropdownOpen(e, 5)}
                    onClose={(e) => this.handleDropdownClose(e, 5)}
                  >
                    { sovNetworks.map(n => {
                      return (
                        <MenuItem key={n.label} value={n.label} className='selectOptionBox'>
                          <span className='menuDot' style={networkDotStyle(n.label)}></span>
                          <Box className="d-flex flex-column pt-0">
                            <span className="optionLabel" style={networkLabelStyle(n.label)}>{this.getDisplayTitle(n.label, 5)}</span>
                          </Box>
                        </MenuItem>
                      )
                    })}
                  </Select>
                  { sovNetwork5.label !== NONE && <h5 className='contPercent networkPercent'>{sovNetwork5Average}%</h5> }
                  { sovNetwork5.label !== NONE && <span className='networkPercent'>{this.getAverage(sovNetwork5, sovNetwork5Average)}% from avg</span> }
                </Box>
              }
            </Box>
            <Box className='chartWrap' id='sovNetworksChart'>
              <Box className='optionBox'>
                <Box className={'iconBox ' + (this.state.actionState === 'line' && 'iconActive')} onClick={() => actionSelect('line')}>
                  <img src="/static/images/line.svg" alt="line" />
                </Box>
                <Box className={'iconBox ' + (this.state.actionState === 'bar' && 'iconActive')} onClick={() => actionSelect('bar')}>
                  <img src="/static/images/bar.svg" alt="line" />
                </Box>
              </Box>
              {this.state.actionState === 'line' &&
                <LineWrap
                  sovNetworks={this.state.sovNetworks}
                  sovNetwork1={this.state.sovNetwork1}
                  sovNetwork2={this.state.sovNetwork2}
                  sovNetwork3={this.state.sovNetwork3}
                  sovNetwork4={this.state.sovNetwork4}
                  sovNetwork5={this.state.sovNetwork5}
                  dateIndex={this.props.dateIndex}
                  selectedDate={this.props.dateArray[this.props.dateIndex]}
                  setDateIndex={this.props.setDateIndex}
                  dateArray={this.props.dateArray}
                />
              }
              { this.state.actionState === 'bar' &&
                <BarWrap
                  sovNetworks={this.state.sovNetworks}
                  sovNetwork1={this.state.sovNetwork1}
                  sovNetwork2={this.state.sovNetwork2}
                  sovNetwork3={this.state.sovNetwork3}
                  sovNetwork4={this.state.sovNetwork4}
                  sovNetwork5={this.state.sovNetwork5}
                  dateIndex={this.props.dateIndex}
                  selectedDate={this.props.dateArray[this.props.dateIndex]}
                  setDateIndex={this.props.setDateIndex}
                  dateArray={this.props.dateArray}
                />
              }
            </Box>
          </>
        }
      </>
    )
  }
}